<template>
  <ul class="list">
    <slot />
  </ul>
</template>
